import styled from 'styled-components';

export const DropdownContentItem = styled.div`
  cursor: pointer;
  padding: 5px 10px;
  white-space: nowrap;

  display: flex;
  justify-content: space-between;

  background-color: var(--neutral-2);
  color: var(--main-2);
  font-family: var(--font-1);
  font-size: 13px;
  border-radius: var(--radius-2);

  transition:
    background-color 0.3s ease,
    color 0.3s ease;

  &:hover {
    background-color: var(--neutral-3);
    color: var(--main-1);
  }
`;
